export default {
  // Navigation
  'home': "Home",
  "detailed": "Complete Report",
  "goshala_charity": "Goshala Donation",
  "about": "About", 
  "contact": "Contact",
  "get_reading": "Get Reading",
  "unlock_destiny": "Unlock Your Destiny",
  "language": "Language",
  
  // Core Horoscope
  "core_horoscope": "Core Horoscope",
  "birth_chart": "Birth Chart / Kundli",
  "match_kundli": "Match Kundli",
  "ascendant_analysis": "Ascendant Analysis",
  "gochar_phal": "Gochar Phal",
  "dasha_analysis": "Dasha Phal Analysis",
  "nakshatra_report": "Nakshatra Report",
  "numerology": "Numerology",
  
  // Life Predictions
  "life_predictions": "Life Predictions",
  "your_life_predictions": "Your Life Predictions",
  "2025_report": "2025 Personalized Report",
  "year_analysis": "Year Analysis",
  "daily_horoscope": "My Day Today",
  "love_compatibility": "Your Love Life",
  "career_guidance": "Career Guidance",
  "nature_analysis": "Your True Nature",
  "health_index": "Health Index",
  
  // Remedial Solutions
  "remedial_solutions": "Remedial Solutions",
  "lal_kitab": "Lal Kitab Horoscope",
  "mangal_dosha": "Mangal Dosha Analysis",
  "kalsarp_dosh": "Kalsarp Dosh Report",
  "sade_sati": "Sade Sati Life Report",
  "ask_question": "Ask A Question",
  "gemstones_report": "Gemstones Report"
};